
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42.014 40.839"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"b","x1":"-84.06","y1":"-36.226","x2":"-84.06","y2":"-36.305","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#74ce00"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#0c9a52"}})]),_c('filter',{attrs:{"id":"a","x":"0","y":"0","width":"100%","height":"100%","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"3"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_c('feFlood',{attrs:{"flood-opacity":".161"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"data-name":"Component 35 – 1"}},[_c('g',{attrs:{"transform":"translate(0 .003)","filter":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 7935","d":"M21.01 6l3.906 7.248 8.1 1.476-5.686 5.955 1.1 8.16-7.421-3.568-7.421 3.568 1.1-8.16-5.686-5.955 8.1-1.476z","fill":"#fff"}})]),_c('path',{attrs:{"data-name":"Path 7935","d":"M1219.55 1487.358l-7.42 3.568 1.1-8.161-5.687-5.959 8.1-1.475 3.906-7.249z","transform":"translate(-1198.543 -1462.16)","fill":"url(#b)"}})])])
          )
        }
      }
    